import { Link } from "react-router-dom";
import { CheckCircle, Users, Award, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import mascotImage from "@/assets/coblynau-mascot.png";

const features = [
  "Local Swansea-based team with rapid response times",
  "Proactive monitoring to prevent issues before they occur",
  "Plain-English explanations - no confusing tech jargon",
  "Flexible support packages tailored to your needs",
  "Microsoft Partner with certified technicians",
  "Commitment to your business success",
];

const About = () => {
  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image & Stats */}
          <div className="relative">
            <div className="relative bg-card rounded-2xl shadow-elevated p-8">
              <img
                src={mascotImage}
                alt="Coblynau IT mascot helping with technology"
                className="w-full max-w-sm mx-auto"
              />
              
              {/* Floating Stats */}
              <div className="absolute -top-4 -left-4 bg-background rounded-xl shadow-soft p-4 animate-float">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <Users className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <p className="text-xl font-bold text-foreground">100+</p>
                    <p className="text-xs text-muted-foreground">Happy Clients</p>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-4 -right-4 bg-background rounded-xl shadow-soft p-4 animate-float" style={{ animationDelay: "1s" }}>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <Award className="h-5 w-5 text-primary" />
                  </div>
                  <div>
                    <p className="text-xl font-bold text-foreground">Microsoft</p>
                    <p className="text-xs text-muted-foreground">Certified Partner</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
              <MapPin className="h-4 w-4" />
              Based in Swansea, Wales
            </div>

            <h2 className="text-3xl sm:text-4xl font-bold text-foreground mb-6">
              Why Choose Coblynau IT Solutions?
            </h2>

            <p className="text-muted-foreground mb-4">
              Like the legendary Coblynau of Welsh folklore who guided miners to rich ore deposits, we guide businesses to the technology solutions they need to thrive. Our name reflects our mission: to be your trusted guide in the digital landscape.
            </p>

            <p className="text-muted-foreground mb-8">
              Based in beautiful Swansea, we understand the unique needs of Welsh businesses. Our friendly, experienced team provides personalised IT support that treats you like a partner, not just another ticket number.
            </p>

            <ul className="space-y-3 mb-8">
              {features.map((feature) => (
                <li key={feature} className="flex items-start gap-3">
                  <CheckCircle className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                  <span className="text-foreground">{feature}</span>
                </li>
              ))}
            </ul>

            <Button asChild size="lg">
              <Link to="/about">Learn More About Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
